import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../../App";
import { checkActive } from "../customFunc";
import "./Tabbar.css";
import icon from "../../../assets/images/password.png";
import homeLogo from "../../../assets/images/homeLogo.svg";
import selectedHomeLogo from "../../../assets/images/selectedHomeLogo.svg";
import syncLogo from "../../../assets/images/syncLogo.svg";
import selectedSyncLogo from "../../../assets/images/selectedSyncLogo.svg";
import translate from "../../../assets/images/translate.png";
import helpLogo from "../../../assets/images/helpLogo.svg";
import scheduleLogo from "../../../assets/images/scheduleLogo.svg";
import selectedHelpLogo from "../../../assets/images/selectedHelpLogo.svg";
import selectedScheduleLogo from "../../../assets/images/selectedScheduleLogo.svg";
import trackLogo from "../../../assets/images/trackLogo.svg";
import selectedTrackLogo from "../../../assets/images/selectedTrackLogo.svg";
import notesLogo from "../../../assets/images/notesLogo.svg";
import selectedNotesLogo from "../../../assets/images/selectedNotesLogo.svg";
import selectedNotifyLogo from "../../../assets/images/selectedMailIcon.png";
import notifyLogo from "../../../assets/images/mailIcon.png";
import login from "../../../assets/images/login.png";
import logoutLogo from "../../../assets/images/logoutLogo.svg";
import loginLogo from "../../../assets/images/loginLogo.svg";
import selectedLoginLogo from "../../../assets/images/selectedLoginLogo.svg";
import { logout, useAuth } from "../../../service/authProvider";
import { Col, Container, Row } from "react-bootstrap";

function Tabbar(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  {
    /* Use a suspense component in the parent or above component to not trigger error */
  }
  const user = useContext(UserContext);
  const [selectedTab, setSelectedTab] = useState("");
  const [isPasswordReset, setIsPasswordReset] = useState(false);

  useEffect(() => {
    setSelectedTab(props.tabName);
    setIsPasswordReset(props.isPasswordReset);
  }, [props]);

  function logoutUser() {
    localStorage.removeItem("leadUser");
    localStorage.removeItem("tempWashInventory");
    localStorage.removeItem("selectedOrgId");
    logout();
    window.location.reload();
    navigate("/");
  }

  function navigateTo(url) {
    if (!checkActive(url)) navigate(url);
    // navigate(url, { replace: true })    //replaces the current stack route in history
  }

  //function to check the current path and returns the selected classname if true
  const applySelected = (path) =>
    window.location.pathname === path ? "tabbar-button-selected" : "";

  return (
    <Container
      style={{ display: isPasswordReset ? "none" : "block", padding: "unset" }}
    >
      <Row className="tabbar">
        <Col
          onClick={() => {
            setSelectedTab("home");
            navigateTo("/");
          }}
          className={"tabbar-button ripple " + applySelected("/")}
        >
          {selectedTab === "home" ? (
            <img src={selectedHomeLogo} width={25} alt={"home-icon"} />
          ) : (
            <img src={homeLogo} width={25} alt={"home-icon"} />
          )}
          <div
            style={{ color: selectedTab === "home" ? "#1890FF" : "#262626" }}
          >
            {t("home.label")}
          </div>
        </Col>

        <Col
          onClick={() => {
            setSelectedTab("schedule");
            navigateTo("/schedule");
          }}
          className={"tabbar-button ripple " + applySelected("/schedule")}
        >
          {selectedTab === "schedule" ? (
            <img src={selectedScheduleLogo} width={25} alt={"schedule-icon"} />
          ) : (
            <img src={scheduleLogo} width={25} alt={"schedule-icon"} />
          )}
          <div
            style={{
              color: selectedTab === "schedule" ? "#1890FF" : "#262626",
            }}
          >
            {t("schedule.label")}
          </div>
        </Col>

        <Col
          onClick={() => {
            setSelectedTab("track");
            navigateTo("/wash-inventory");
          }}
          className={"tabbar-button ripple " + applySelected("/wash-inventory")}
        >
          {selectedTab === "track" ? (
            <img src={selectedTrackLogo} width={25} alt={"track-icon"} />
          ) : (
            <img src={trackLogo} width={25} alt={"track-icon"} />
          )}
          <div
            style={{ color: selectedTab === "track" ? "#1890FF" : "#262626" }}
          >
            {t("track.label")}
          </div>
        </Col>

        <Col
          onClick={() => {
            setSelectedTab("notes");
            navigateTo("/notes");
          }}
          className={"tabbar-button ripple " + applySelected("/notes")}
        >
          {selectedTab === "notes" ? (
            <img src={selectedNotesLogo} width={25} alt={"track-icon"} />
          ) : (
            <img src={notesLogo} width={25} alt={"track-icon"} />
          )}
          <div
            style={{ color: selectedTab === "notes" ? "#1890FF" : "#262626" }}
          >
            {t("notes.label")}
          </div>
        </Col>

        <Col
          onClick={() => {
            setSelectedTab("notify");
            navigateTo("/notify");
          }}
          className={"tabbar-button ripple " + applySelected("/notify")}
        >
          {selectedTab === "notify" ? (
            <img src={selectedNotifyLogo} width={25} alt={"notify-icon"} />
          ) : (
            <img src={notifyLogo} width={25} alt={"notify-icon"} />
          )}
          <div
            style={{ color: selectedTab === "notify" ? "#1890FF" : "#262626" }}
          >
            {t("notify.label")}
          </div>
        </Col>

        <Col
          onClick={() => {
            setSelectedTab("sync");
            navigateTo("/sync");
          }}
          className={"tabbar-button ripple " + applySelected("/sync")}
        >
          {selectedTab === "sync" ? (
            <img src={selectedSyncLogo} width={25} alt={"sync-icon"} />
          ) : (
            <img src={syncLogo} width={25} alt={"sync-icon"} />
          )}
          <div
            style={{ color: selectedTab === "sync" ? "#1890FF" : "#262626" }}
          >
            {t("sync.label")}
          </div>
        </Col>

        {useAuth() ? (
          <Col onClick={() => logoutUser()} className={"tabbar-button ripple "}>
            <img src={logoutLogo} width={25} alt={"logout-icon"} />
            <div>{t("logout.label")}</div>
          </Col>
        ) : (
          <Col
            onClick={() => {
              // setSelectedTab('login');
              navigateTo("/login");
            }}
            className={"tabbar-button ripple " + applySelected("/login")}
          >
            {selectedTab === "login" ? (
              <img src={selectedLoginLogo} width={25} alt={"login-icon"} />
            ) : (
              <img src={loginLogo} width={25} alt={"login-icon"} />
            )}
            <div
              style={{ color: selectedTab === "login" ? "#1890FF" : "#262626" }}
            >
              {t("login.label")}
            </div>
          </Col>
        )}
      </Row>
    </Container>
  );
}

export default Tabbar;
